import React, { useContext, Suspense, useState } from 'react';
import { connect } from 'react-redux';

import TerritoryKPIs from 'components/data-containers/KPIs/Territory/Territory';
import TerritoryTable from 'components/data-containers/TerritoryTable/TerritoryTable';
import { EntityContext, SalesTypes } from 'context/entityContext';
import TerritoryMapSkeletonLoader from 'components/data-containers/ChoroplethMap/shared/SkeletonLoader';
import { IHasExternalUserProps } from 'pages/Entity/shared';
import TopicFilters from 'components/TopicFilters/TopicFilters';
import SubNavigation from 'components/SubNavigation/SubNavigation';
import { audienceSubTopics } from 'topics';

const TerritoryMap = React.lazy((): any =>
  import('components/data-containers/ChoroplethMap/TerritoryMap')
);

const Territory: React.FC<IHasExternalUserProps> = (props) => {
  const ctx = useContext(EntityContext);
  const { compareMode, filters, topic } = ctx;

  const { isExternalUser } = props;

  const [selectedSalesTypedMap, setSelectedSalesTypeMap] = useState<
    SalesTypes
  >();
  const [selectedSalesTypedTable, setSelectedSalesTypeTable] = useState<
    SalesTypes
  >();
  const selectedSalesType = selectedSalesTypedMap || selectedSalesTypedTable;

  return (
    // Note: Do not remove the next <div>. It avoids flexbox to double margins between generic components.
    <div>
      <SubNavigation topic="audience" variants={audienceSubTopics} />

      <TopicFilters
        topic={topic[1] || topic[0]}
        compareMode={compareMode}
        selectedSalesType={selectedSalesType}
      />

      <TerritoryKPIs
        glossarySlug="kpis/territory-kpis"
        isExternalUser={isExternalUser}
        globalFilters={filters}
        {...ctx}
      />

      <Suspense
        fallback={<TerritoryMapSkeletonLoader showSalesTypesDropdown />}
      >
        <TerritoryMap setSelectedSalesType={setSelectedSalesTypeMap} />
      </Suspense>

      {!compareMode && (
        <TerritoryTable
          isExternalUser={isExternalUser}
          setSelectedSalesType={setSelectedSalesTypeTable}
        />
      )}
    </div>
  );
};

export default connect((store: any) => ({
  isExternalUser: store.authentication.isExternalUser,
}))(Territory);
